import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	mode: 'add',
	isLoading: false,
	isVerified: false,
	lastVerifiedValues: {
		businessId: null,
		userAccessToken: null
	},
	defaultConnection: false
};

const WhatsappBusiness = createSlice({
	name: 'WhatsappBusiness',
	initialState,
	reducers: {
		setMode: (state, { payload }) => ({ ...state, mode: payload }),
		setIsLoading: (state, { payload }) => ({ ...state, isLoading: payload }),
		setIsVerified: (state, { payload }) => ({ ...state, isVerified: payload }),
		setLastVerifiedValues: (state, { payload }) => ({ ...state, lastVerifiedValues: payload }),
		setDefaultConnection: (state, { payload }) => ({ ...state, defaultConnection: payload }),
		setStateToDefault: () => ({ ...initialState })
	}
});

export const { setMode, setIsLoading, setIsVerified, setLastVerifiedValues, setDefaultConnection, setStateToDefault } =
	WhatsappBusiness.actions;

export default WhatsappBusiness.reducer;
